import { Observable } from 'rxjs';
import { ApiKeyRepository } from '../domain/api-keys/repository';
import { ApiKey, CreatedApiKey, CreateApiKeyDTO } from '../domain/api-keys/entity';
import HttpClient from '../utils/http-client';

export class ApiKeyRepositoryImplementation extends ApiKeyRepository {
    list(uid: string, cid: string | null): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get<any>(`/accountant/api-keys`);
    }

    create(uid: string, cid: string | null, data: CreateApiKeyDTO): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post<any>(`/accountant/api-keys`, data);
    }

    delete(uid: string, cid: string | null, id: number): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.delete<any>(`/accountant/api-keys/${id}`);
    }
}
